const api = "https://emfuom5ojj.execute-api.us-east-1.amazonaws.com/prod/search"
module.exports = api;